import { ServiceType } from '@types';

export function getDefaultVisitType(serviceType: ServiceType) {
  return serviceType.visitTypes[0];
}

export const addictionTreatment = {
  title: 'Manage opioid addiction with medication support',
  description:
    'Get judgment-free care for cravings and withdrawals. Book same-day consultations online, starting at $99.',
};
export const urgentCare = {
  title: 'Get urgent care with online doctor visits',
  description:
    'Access quick care for minor illnesses and injuries online. Book same-day visits with licensed providers for just $75.',
};
export const weightLoss = {
  title: 'Achieve your goals with weight loss medications',
  description:
    'Discover safe, effective GLP-1 treatments like Ozempic and Wegovy. Weight loss consultations start at just $99 – no insurance required.',
};
export const primaryCare = {
  title: 'Convenient online primary care for your everyday health',
  description:
    'Connect with licensed providers for routine care, prescriptions, and more—all from the comfort of home.',
};
export const counseling = {
  title: 'Online counseling and support to help you thrive',
  description:
    'Talk to a licensed counselor today. Secure, virtual sessions start at $19 to help you handle stress and life’s transitions.',
};

export const defaultText = {
  title: 'Let’s get started',
  description: 'You are taking the first step towards better health.',
};

const knownServiceParamTitles: {
  [key: string]: { title: string; description: string };
} = {
  // Production IDs
  '972': addictionTreatment,
  '11987721': weightLoss,
  '8351221': primaryCare,
  '973': urgentCare,
  '8371465': counseling,
  // Dev/QA IDs
  'f492bba8-89b7-4e33-aeda-f8c24852864e': addictionTreatment,
  '41d7cecf-a90b-478a-82e4-2a0c29f50482': weightLoss,
  '0764fcaf-bc1d-4252-a261-3f3dcb19fd32': primaryCare,
  '9774df5f-2b47-4049-94b5-e7d1ca69f8d6': urgentCare,
  '9323a866-b3f9-42af-8e84-4654d1aeeefb': counseling,
  default: defaultText,
};

const fallback = { title: '', description: '' };

export function getHeaderText(serviceParam?: string | null) {
  const { title, description } =
    knownServiceParamTitles[serviceParam ?? 'default'] ??
    knownServiceParamTitles.default ??
    fallback;

  return { title, description };
}
